import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import type {CustomerOtp} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/customerAuthenticationWorkspaceCapability/domain/CustomerOtp";
import type {CustomerOtpChannel} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/customerAuthenticationWorkspaceCapability/domain/CustomerOtpChannel";
import {CustomerAuthenticationWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/customerAuthenticationWorkspaceCapability/domain/CustomerAuthenticationWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type CustomerOtpFields = Omit<CustomerOtp, "createdAt" | "id">;
export type CustomerOtpChannelFields = CustomerOtpChannel & {otpId: Uuid};
export type CustomerAuthenticationWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.customerAuthentication> & {
    fixedUdoTemplates: {
        [CustomerAuthenticationWorkspaceCapabilityUdoTemplateKey.customerOtp]: {
            udoAdditionalColumnIds: {
                consumedAt: Uuid;
                eventContainerTemplateId: Uuid;
                expiresAt: Uuid;
                isConsumed: Uuid;
                otpHash: Uuid;
            };
        };
        [CustomerAuthenticationWorkspaceCapabilityUdoTemplateKey.customerOtpChannel]: {
            udoAdditionalColumnIds: {
                channelType: Uuid;
                identifier: Uuid;
                otpId: Uuid;
            };
        };
    };
};
export const customerAuthenticationWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [CustomerAuthenticationWorkspaceCapabilityUdoTemplateKey.customerOtp]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({
                consumedAt: uuidZodValidator,
                eventContainerTemplateId: uuidZodValidator,
                expiresAt: uuidZodValidator,
                isConsumed: uuidZodValidator,
                otpHash: uuidZodValidator,
            }),
            udoTemplateId: uuidZodValidator,
        }),
        [CustomerAuthenticationWorkspaceCapabilityUdoTemplateKey.customerOtpChannel]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({channelType: uuidZodValidator, identifier: uuidZodValidator, otpId: uuidZodValidator}),
            udoTemplateId: uuidZodValidator,
        }),
    }),
}) satisfies zod.ZodType<CustomerAuthenticationWorkspaceCapabilityUdoBindings>;
